// This is used by components like AssetBreadcrumbs and AssetTabs to determine which asset types to show.

import { FeatureFlag } from 'constants/feature-flags'

type LibraryInfo = {
  basePath: string // base part of URL
  label: string
  hidden?: boolean // not shown on tab bar
  featureFlag?: FeatureFlag // only available with feature flag
}

export const LIBRARY_INFO: LibraryInfo[] = [
  // Legacy
  {
    basePath: 'tool-libraries',
    label: 'Tool Libraries',
  },
  {
    basePath: 'cut-configs',
    label: 'Cut Configs',
    hidden: true, // has separate entry on main menu
  },

  // Assets - basePath should match AssetType
  {
    basePath: 'stock',
    label: 'Stock Settings',
  },
  {
    basePath: 'material',
    label: 'Materials',
    featureFlag: 'canEditMaterials',
  },
  {
    basePath: 'machine',
    label: 'Machines',
    featureFlag: 'canEditMachines',
  },

  {
    basePath: 'estimate-preset',
    label: 'Estimate Presets',
  },
]

export const LIBRARY_PATHS: string[] = LIBRARY_INFO.filter(
  (info) => !info.hidden,
).map((info) => info.basePath)
